import { TableHeaderBlack } from '../../../report-pdf/components'

export { TableHeaderBlack }
